import PropTypes from "prop-types";
import React, { Component } from "react";
import config from "../config";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
const styles = (theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  problem: {
    width: "100%",
  },
  fab: {
    margin: theme.spacing(2),
  },
  absolute: {
    position: 'absolute',
    top: theme.spacing(5),
    right: theme.spacing(3),
  },
});


class DraftView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      results: [],
      editing: false,
      input_title: "",
      input_problem_image: null,
      input_answer_image: null,
      input_comment: "",
      submitting: false,
    };
  }

  load_drafts = () => {
    this.setState({ loading: true });
    if (this.props.user_id) {
      return fetch(
        config.backend_url + "drafts/" + this.props.user_id
      ).then((response) => {
        response.json().then((json) => {
          this.setState({ results: json, loading: false });
        });
      });
    }
  }

  componentDidMount() {
    return this.load_drafts();
  }

  componentWillReceiveProps() {
    return this.load_drafts();
  }

  render() {
    const { classes } = this.props;
    const handleClose = () => { this.setState({ editing: false }) }
    const handleSubmit = () => {
      const formData = new FormData();
      formData.append('user_id', this.props.user_id)
      formData.append('title', this.state.input_title)
      formData.append('problem_file', this.state.input_problem_image)
      formData.append('answer_file', this.state.input_answer_image)
      formData.append('comment', this.state.input_comment)

      this.setState({ submitting: true })
      fetch(config.backend_url + "new/draft", {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
        },
        body: formData,
      }).then((response) => {
        response.json().then((json) => {
          this.setState({ submitting: false, editing: false, input_title: '', input_problem_image: null, input_answer_image: null, input_comment: '' })
          this.load_drafts();
        });
      });

    }

    return (
      <div>
        <div className={classes.header}>
          <div>
            <h1>作問</h1>
          </div>
          <div>
            <Tooltip title="Add" aria-label="add"  onClick={() => { this.setState({ editing: true }) }} > 
              <Fab color="primary" className={classes.fab}>
                <AddIcon/>
              </Fab>
            </Tooltip>
          </div>
        </div>
        <Dialog open={this.state.editing} onClose={handleClose}>
          <DialogTitle id="form-dialog-title">新しい問題を投稿する</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="問題名"
              type="text"
              fullWidth
              value={this.state.input_title}
              onChange={(e) => this.setState({ input_title: e.target.value })}
            />
            <div>
              問題画像：&nbsp;
                  <input
                id="problem-image"
                type="file"
                accept="image/*"
                onChange={(e) => { this.setState({ input_problem_image: e.target.files.item(0) }) }}
              />
            </div>
            <div>
              解説画像：&nbsp;
                  <input
                id="answer-image"
                type="file"
                accept="image/*"
                onChange={(e) => { this.setState({ input_answer_image: e.target.files.item(0) }) }} />
            </div>

            <TextField
              margin="dense"
              id="comment"
              label="コメント"
              type="text"
              fullWidth
              value={this.state.input_comment}
              onChange={(e) => this.setState({ input_comment: e.target.value })}

            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSubmit} color="primary"
              disabled={!(this.state.input_title && this.state.input_problem_image && this.state.input_answer_image && this.state.input_comment && !this.state.submitting)}>
              送信
                </Button>
          </DialogActions>
        </Dialog>
        <div>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">タイトル</TableCell>
                  <TableCell align="left">ステータス</TableCell>
                  <TableCell align="left">コメント</TableCell>
                  <TableCell align="left" width="20%">問題</TableCell>
                  <TableCell align="left" width="20%">解説</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  <TableRow key="example">
                      <TableCell component="th" scope="row" align="left">
                          例題
                      </TableCell>
                      <TableCell align="left">ACCEPTED</TableCell>
                      <TableCell align="left">易しい難易度の問題です</TableCell>
                      <TableCell align="left"><a href="https://nazocon.netlify.app/nazo/problems/91e07496af-1.png"><img src="https://nazocon.netlify.app/nazo/problems/91e07496af-1.png" width="100%"/></a></TableCell>
                      <TableCell align="left"><a href="https://nazocon.netlify.app/nazo/solutions/91e07496af-1.png"><img src="https://nazocon.netlify.app/nazo/solutions/91e07496af-1.png" width="100%"/></a></TableCell>
                  </TableRow>
                {this.state.results.map((row) => (
                  <TableRow key={row.draft_id}>
                    <TableCell component="th" scope="row" align="left">
                      {row.title}
                    </TableCell>
                    <TableCell align="left">{row.status}</TableCell>
                    <TableCell align="left">{row.comment}</TableCell>
                    <TableCell align="left"><a href={row.problem_image_url}><img src={row.problem_image_url} width="100%"/></a></TableCell>
                    <TableCell align="left"><a href={row.answer_image_url}><img src={row.answer_image_url} width="100%"/></a></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  }
}

DraftView.propTypes = {
  user_id: PropTypes.string,
  user_name: PropTypes.string,
};

class CreateDraftView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      results: [],
    };
  }

  submit() {
    return fetch(
      config.backend_url + "draft/my?user_id=" + this.props.user_id
    ).then((response) => {
      response.json().then((json) => {
        this.setState({ results: json, loading: true });
      });
    });
  }

  render() {

    return (
      <div>
        <h1>新しい問題を作る</h1>

      </div>
    );
  }
}


export default withStyles(styles)(DraftView);
